module.exports = __webpack_public_path__ + "img/serifnew_box09.0f96e38f.jpg";